module.exports = __webpack_public_path__ + "zw.svg?25d67323ce7c449da65ae3af13fac562";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/zw.svg
// module id = 1452
// module chunks = 0